"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var SpacingWidth = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "spacing-width" },
            react_1.default.createElement("path", { id: "Icon", d: "M6 12L5.16795 11.4453C4.94402 11.7812 4.94402 12.2188 5.16795 12.5547L6 12ZM18 12L18.8321 12.5547C19.056 12.2188 19.056 11.7812 18.8321 11.4453L18 12ZM16.8321 8.4453C16.5257 7.98577 15.9048 7.8616 15.4453 8.16795C14.9858 8.4743 14.8616 9.09517 15.168 9.5547L16.8321 8.4453ZM15.1679 14.4453C14.8616 14.9048 14.9858 15.5257 15.4453 15.8321C15.9048 16.1384 16.5257 16.0142 16.8321 15.5547L15.1679 14.4453ZM8.83205 9.5547C9.1384 9.09517 9.01423 8.4743 8.5547 8.16795C8.09517 7.8616 7.4743 7.98577 7.16795 8.4453L8.83205 9.5547ZM7.16795 15.5547C7.4743 16.0142 8.09517 16.1384 8.5547 15.8321C9.01423 15.5257 9.1384 14.9048 8.83205 14.4453L7.16795 15.5547ZM20 21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21H20ZM22 3C22 2.44772 21.5523 2 21 2C20.4477 2 20 2.44772 20 3H22ZM2 21C2 21.5523 2.44772 22 3 22C3.55228 22 4 21.5523 4 21H2ZM4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3H4ZM6 13H18V11H6V13ZM15.168 9.5547L17.1679 12.5547L18.8321 11.4453L16.8321 8.4453L15.168 9.5547ZM17.1679 11.4453L15.1679 14.4453L16.8321 15.5547L18.8321 12.5547L17.1679 11.4453ZM7.16795 8.4453L5.16795 11.4453L6.83205 12.5547L8.83205 9.5547L7.16795 8.4453ZM5.16795 12.5547L7.16795 15.5547L8.83205 14.4453L6.83205 11.4453L5.16795 12.5547ZM22 21V3H20V21H22ZM4 21V3H2V21H4Z" }))));
};
exports.default = SpacingWidth;
